import { FC } from "react";
import { IconProps } from "./types";

export const CaretDownSolid: FC<IconProps> = ({
  fill = "#000",
  width = 24,
  height = 24,
  className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={className}
    {...props}
  >
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M12 17 4 7h16l-8 10z"
      fill={fill}
    />
  </svg>
);
